import React, { useEffect } from 'react';
import { NavLink, useRouteError } from 'react-router-dom';
import routes from '../../routes';
import { Container, Row } from 'react-bootstrap';
import { useAppSelector } from '../../hooks/defaultHooks';
import { getTheme } from '../../selectors/selectors';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const ErrorPage = () => {
  const error = useRouteError();
  useDocumentTitle('Application Error');
  const [errorText, setErrorText] = React.useState('');
  const theme = useAppSelector(getTheme);
  useEffect(() => {
    if (error) {
      setErrorText(JSON.stringify(error, null, 2));
    }
  }, [error]);
  return (
    <Container className={`${theme}-root-container`} fluid>
      <Row>
        <p>
          An unexpected error occurred while the application was running - {errorText}. Please
          contact the administrator.
        </p>
      </Row>
      <Row>
        <NavLink to={routes.pages.mainPage()}>Return to the main page</NavLink>
      </Row>
    </Container>
  );
};

export default ErrorPage;
